import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import TileAdhesiveHero from './components/TileAdhesiveHero';
import TileAdhesiveTierComparison from './components/TileAdhesiveTierComparison';
import TileAdhesiveFeatures from './components/TileAdhesiveFeatures';
import ContactCTA from '../components/ContactCTA';

export default function TileAdhesivePage() {
  return (
    <div className="min-h-screen bg-[#1A1A1A]">
      <Navbar />
      <TileAdhesiveHero />
      <TileAdhesiveTierComparison />
      <TileAdhesiveFeatures />
      <ContactCTA />
      <Footer />
    </div>
  );
}
